(() => {
  if (document.documentElement.hasAttribute('data-auriani-navigation-ready')) return;
  document.documentElement.setAttribute('data-auriani-navigation-ready', '');
  const controller = new AbortController();
  const openers = new WeakMap();
  const disclosureSelector = '.mega-nav,.catalog-filter';
  document.addEventListener('click', event => {
    const summary = event.target.closest('.desktop-nav .mega-nav > summary');
    if (summary?.parentElement.dataset.pointerOpened === 'true') {
      if (event.detail > 0) event.preventDefault();
      delete summary.parentElement.dataset.pointerOpened;
    }
    let openedDialog = null;
    const open = event.target.closest('[data-open-dialog]');
    if (open) {
      const dialog = document.getElementById(open.dataset.openDialog);
      if (dialog && !dialog.open && typeof dialog.showModal === 'function') {
        openers.set(dialog, open);
        dialog.showModal();
        openedDialog = dialog;
        open.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-dialog-autofocus]')?.focus();
      }
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog[open]') && openers.has(event.target)) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    document.querySelectorAll(disclosureSelector).forEach(el => {
      if (openedDialog?.contains(el)) return;
      if (el.open && !el.contains(event.target)) el.removeAttribute('open');
    });
  }, { signal: controller.signal });
  document.addEventListener('change', event => {
    if (!event.target.matches('.catalog-filters--drawer input[name="sort_by"]')) return;
    const summary = event.target.closest('form')?.querySelector('[data-sort-summary]');
    if (summary) summary.textContent = event.target.closest('label')?.querySelector('span')?.textContent || '';
  }, { signal: controller.signal });
  document.addEventListener('keydown', event => {
    const menu = event.target.closest('.desktop-nav .mega-nav');
    if (menu && event.target.matches('summary')) {
      const menus = [...menu.parentElement.querySelectorAll('.mega-nav')];
      const index = menus.indexOf(menu);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        menu.open = true;
        menu.querySelector('a')?.focus();
        return;
      }
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        menu.open = false;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? menus.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + menus.length) % menus.length;
        menus[next]?.querySelector('summary')?.focus();
        return;
      }
    }
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const disclosure = event.target.closest(disclosureSelector);
    if (disclosure?.open) {
      event.preventDefault();
      disclosure.removeAttribute('open');
      disclosure.querySelector('summary')?.focus();
    }
  }, { signal: controller.signal });
  document.addEventListener('focusout', event => {
    const disclosure = event.target.closest('.mega-nav');
    if (disclosure?.open && event.relatedTarget && !disclosure.contains(event.relatedTarget)) disclosure.removeAttribute('open');
  }, { signal: controller.signal });
  document.addEventListener('close', event => {
    const form = event.target.querySelector?.('[data-catalog-form]');
    if (form) {
      form.reset();
      form.querySelectorAll('input').forEach(input => input.setCustomValidity(''));
      const summary = form.querySelector('[data-sort-summary]');
      const selected = form.querySelector('input[name="sort_by"]:checked');
      if (summary) summary.textContent = selected?.closest('label')?.querySelector('span')?.textContent || '';
    }
    const opener = openers.get(event.target);
    if (!opener) return;
    openers.delete(event.target);
    opener.setAttribute('aria-expanded', 'false');
    if (opener.isConnected) opener.focus();
  }, { capture: true, signal: controller.signal });
  document.querySelectorAll('.desktop-nav .mega-nav').forEach(menu => {
    let closeTimer;
    menu.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || !matchMedia('(min-width:990px)').matches) return;
      clearTimeout(closeTimer);
      document.querySelectorAll('.desktop-nav .mega-nav[open]').forEach(other => { if (other !== menu) other.open = false; });
      if (!menu.open) menu.dataset.pointerOpened = 'true';
      menu.open = true;
    });
    menu.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse') closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 160);
    });
  });
  const header = document.querySelector('.shopify-section-group-header-group');
  if (header && typeof ResizeObserver === 'function') {
    new ResizeObserver(() => document.documentElement.style.setProperty('--reference-header-height', header.offsetHeight + 'px')).observe(header);
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches('.mega-nav[open]')) document.querySelectorAll('.mega-nav[open]').forEach(el => { if (el !== event.target) el.removeAttribute('open'); });
    if (event.target.matches('.catalog-filter[open]')) event.target.closest('form')?.querySelectorAll('.catalog-filter[open]').forEach(el => { if (el !== event.target) el.removeAttribute('open'); });
  }, { capture: true, signal: controller.signal });
})();
